<template>
	<div id="header" :class="headerStyle">
		<div class="header-nav container hidden-xs">
			<div class="header-nav-logo">
				<img src="@/assets/img/logo.png">
				<div class="name-box">
					<div class="logo-name">華瑞達集團</div>
					<div class="logo-enName">HUARUIDA&nbsp;GROUP</div>
				</div>
			</div>
			<ul class="header-nav-wrapper">
				<li v-for="(item,index) in navList" :key="index" :class="index==menuActive?'active':''"
					@click="navClick(index,item.name,item.path)">
					<a style="cursor: pointer;">
						{{item.name}}
						<!-- <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span> -->
						<i class="underline"></i>
					</a>
					<!-- <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl> -->
				</li>
			</ul>
		</div>
		<!-- 手机导航 -->
		<div class="header-nav-m container-fuild visible-xs">
			<div class="header-nav-logo">
				<img src="@/assets/img/logo.png">
				<div class="name-box">
					<div class="logo-name">華瑞達集團</div>
					<div class="logo-enName">HUARUIDA·GROUP</div>
				</div>
			</div>
			<div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
				<span style="background-image: url('../assets/img/mobile/menu_icon.png');"></span>
			</div>
			<div class="header-nav-m-menu text-center">


				<ul id="menu" class="header-nav-m-wrapper collapse">
					<li v-for="(item,index) in navList" :key="index" :class="index==menuActive?'active':''"
						@click="navClick(index,item.name,item.path)" data-toggle="collapse" data-target="#menu">
						<router-link :to="item.path">
							{{item.name}}
							<i class="underline"></i>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
  import { mapState } from 'vuex'
	export default {
		name: "Header",
		data() {
			return {
				menuName: "首頁",
				menuClass: "glyphicon glyphicon-menu-down",
				headerStyle: "",
				navList: [{
						name: "首頁",
						path: "/",
						children: []
					},
					{
						name: "華瑞達概況",
						path: "/survey",
						children: []
					},
					{
						name: "資質榮譽",
						path: "/honor",
						children: []
					},
					{
						name: "經典工程",
						path: "/engineering",
						children: []
					},
					{
						name: "加入華瑞達",
						path: "/join",
						children: []
					},
					{
						name: "新聞中心",
						path: "/news",
						children: []
					},
					{
						name: "人力資源",
						path: "/resources",
						children: []
					},
					{
						name: "聯系我們",
						path: "/contactUs",
						children: []
					}
				]
			};
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
		},
    computed: {
      ...mapState({
        menuActive: state => state.app.menuActive
      }),
    },
		methods: {
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				if (scrollTop > 10) {
					this.headerStyle = "headActive"
				} else {
					this.headerStyle = ""
				}
			},
			navClick(index, name, path) {
				this.menuName = name;
				document.documentElement.scrollTop = 0;
				this.$router.push(path)
			},
			menuClick() {
				if (this.menuClass == "glyphicon glyphicon-menu-down") {
					this.menuClass = "glyphicon glyphicon-menu-up";
				} else {
					this.menuClass = "glyphicon glyphicon-menu-down";
				}
			}
		}
	};
</script>
<style scoped>
	/* 顶部 */
	#header {
		/* background: #f4f4f4; */
		transition: all ease 0.6s;
		z-index: 999;
		position: fixed;
		width: 10rem;
		height: 0.58rem;

	}

	.headActive {
		background-color: rgba(0, 0, 0, 0.4);
	}

	/* 导航栏 */
	#header .header-nav {
		height: 0.58rem;
		width: 100% !important;
		display: flex;
		justify-content: center;
		border-bottom: 0.01rem solid rgba(255, 255, 255, 0.2);
	}

	/* 导航栏logo */
	#header .header-nav .header-nav-logo {
		width: 1.32rem;
		height: 100%;
		/* float: left; */
		position: relative;
		display: flex;
		justify-content: center;
		margin-right: .18rem;
	}

	/* 导航栏logo图片 */
	#header .header-nav .header-nav-logo img {
		width: 0.39rem;
		height: 0.28rem;
		/* position: absolute; */
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}

	.header-nav-logo .name-box {
		display: flex;
		flex-direction: column;
		justify-content: center;
		margin-left: 0.08rem;
	}

	#header .header-nav .header-nav-logo .logo-name {
		font-size: 0.16rem;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #B8312D;
		justify-content: center;
		text-align: center;
		width: 0.85rem;
	}

	#header .header-nav .header-nav-logo .logo-enName {
		font-size: 0.078rem;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #9F969B;
		justify-content: center;
		text-align: center;
		width: 0.85rem;
	}

	/* 导航栏 导航容器 */
	#header .header-nav-fixed .header-nav-wrapper {
		line-height: 0.295rem;
	}

	#header .header-nav .header-nav-wrapper {
		display: flex;
		justify-content: center;
		line-height: 0.59rem;
		height: 100%;
		/* float: right;
  margin: 0; */
		/* max-width: 800px; */
	}

	/* 导航栏 每个导航 */
	#header .header-nav .header-nav-wrapper>li {
		float: left;
		padding: 0 0.09rem;
		position: relative;
		letter-spacing: 2px;
	}

	/* 导航栏 每个导航下面的 a 链接  font-weight: bold;*/
	#header .header-nav .header-nav-wrapper>li>a {
		color: #ffffff;
		font-size: 0.1rem;
		
		padding: 0.07rem 0;
		position: relative;
	}

	/* 导航栏 每个导航下面的 a 链接的下划线 */
	#header .header-nav .header-nav-wrapper>li>a>i {
		display: block;
		position: absolute;
		bottom: -2px;
		left: 50%;
		width: 0;
		height: 2px;
		opacity: 0;
		transition: all 0.6s ease;
		background-color: #B03630;
	}

	/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
	#header .header-nav .header-nav-wrapper>li>a>span {
		font-size: 12px;
		transition: transform ease 0.5s;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
	/* #header .header-nav .header-nav-wrapper > li:hover{
  background-color: #B03630;
} */
	#header .header-nav .header-nav-wrapper>li:not(.active)>a:hover {
		color: #B03630;
		text-decoration: none;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover .underline {
		opacity: 1;
		width: 100%;
		left: 0;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover span {
		transform: rotate(180deg);
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
	#header .header-nav .header-nav-wrapper>li.active {
		background-color: #B03630;
	}

	#header .header-nav .header-nav-wrapper>li.active>a {
		/* color: #1e73be; */
		text-decoration: none;
		/* border-bottom: 2px solid #1e73be; */
	}

	/* 导航栏 每个导航下面的二级导航容器 */
	#header .header-nav .header-nav-wrapper>li>dl {
		display: none;
		position: absolute;
		width: 168px;
		top: 80%;
		left: 0;
		z-index: 999999;
		box-shadow: 0 0 3px 1px #ccc;
		background: #fff;
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航 */
	#header .header-nav .header-nav-wrapper>li>dl>dt {
		width: 100%;
		padding: 0.05rem;
		border-bottom: 1px solid #ccc;
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
	#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
		text-decoration: none;
	}

	/* 导航栏 滑上一级导航显示二级导航 */
	#header .header-nav .header-nav-wrapper>li:hover dl {
		display: block;
	}

	#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
		cursor: pointer;
		background: #ccc;
	}

	@media screen and (max-width: 768px) {
		#header {
			height: 1.38rem;
		}
		#header .header-nav-m {
			position: relative;
		}
		/* 导航栏logo */
		#header .header-nav-m .header-nav-logo {
			width: 5rem;
			height: 100%;
			position: relative;
			display: flex;
			justify-content: center;
			margin-right: .18rem;
			margin-top: 0.36rem;
			margin-left: 0.4rem;
		}

		/* 导航栏logo图片 */
		#header .header-nav-m .header-nav-logo img {
			width: 1rem;
			height: 0.72rem;
			/* position: absolute; */
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			/* margin: auto; */
		}

		#header .header-nav-m .header-nav-logo .name-box {
			display: flex;
			flex-direction: column;
			justify-content: center;
			/* margin-left: 0.08rem; */
		}

		#header .header-nav-m .header-nav-logo .logo-name {
			font-size: 0.35rem;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #ffffff;
		}

		#header .header-nav-m .header-nav-logo .logo-enName {
			font-size: 0.11rem;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #ffffff;
			justify-content: center;
		}
		/* 导航栏  菜单容器 */
		#header .header-nav-m .header-nav-m-menu {
			color: #fff;
			height: 1.4rem;
			font-size: 1.2rem;
			line-height: 1.2rem;
			/* background: #474747; */
			position: relative;
		}

		/* 导航栏 菜单图标 */
		#header .header-nav-m .header-nav-m-menu-wrapper {
			position: absolute;
			top: .2rem;
			right: 0.6rem;
			width: .57rem;
			height: .41rem;
			color: #fff;
			z-index: 999999;
			font-size: 1rem;
			background: url('../assets/img/mobile/menu_icon.png');
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}

		/* 导航栏 */
		#header .header-nav-m .header-nav-m-wrapper {
			position: absolute;
			top: 0.098rem;
			left: 0;
			width: 100%;
			/* background: #474747; */
			background: url('../assets/img/menubg.png');
			background-repeat: no-repeat;
			background-size: 100% 100%;
			z-index: 9999;
		}

		/* 导航栏 每个导航 */
		#header .header-nav-m .header-nav-m-wrapper>li {
			height: 1.2rem;

			border-bottom: 1px solid #ccc;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		/* 导航栏 每个导航下面的 a 链接 */
		#header .header-nav-m .header-nav-m-wrapper>li>a {
			color: #3e3e3e;
			font-size: 0.33rem;
			font-weight: 500;
			/* padding: 0.07rem 0; */
			position: relative;
		}
		#header .header-nav-m .header-nav-m-wrapper>li.active>a {
			color: #B8312D !important;
			text-decoration: none;
			/* border-bottom: 2px solid #1e73be; */
		}
		/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
		#header .header-nav .header-nav-wrapper>li>a>span {
			font-size: 0.05rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue